import { Box, Text } from '@factorialco/deprecated-design-system'
import DOMPurify from 'dompurify'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'

const Description = () => {
  const { form } = useFormProvider()

  const { instruction } = form.values

  return (
    <>
      {!!instruction && (
        <>
          <Box paddingY="s16">
            <Text.Normal weight="semibold" color="grey1000">
              {i18n.t('processes.process_settings.wizard.tasks.preview.labels.task_description')}
            </Text.Normal>
          </Box>
          <Text.Normal>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(instruction),
              }}
            />
          </Text.Normal>
        </>
      )}
    </>
  )
}

export default Description
